import { Patient } from '@bioliberty/lifemind';
import { Building2, ChevronRight, CircleUser } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuthentication } from '../../../auth';
import { Card, CardContent, CardHeader } from '../../../components/Card';
import { Heading } from '../../../components/Heading';
import { NoCapture } from '../../../components/NoCapture';
import { formatDate } from '../../../util/date';
import { getSubtenantLabel } from '../../../util/profile';
import { EmptyRecentPatientsList } from './EmptyRecentPatientsList';

export interface RecentPatientsListProps {
  patients: Patient[];
}

export function RecentPatientsList({ patients }: RecentPatientsListProps) {
  const currentUser = useAuthentication();

  if (!patients.length) {
    return <EmptyRecentPatientsList />;
  }

  return (
    <ul className="flex flex-row gap-5 overflow-auto" data-testid="recent-patients-list">
      {patients.map((patient) => (
        <li key={patient.id}>
          <Link to={`/patients/${patient.id}`}>
            <Card className="w-96 cursor-pointer">
              <CardHeader className="flex flex-row justify-between">
                <div className="flex flex-col gap-2">
                  <div className="flex items-center gap-2">
                    <CircleUser />
                    <Heading size="sm" className="line-clamp-1">
                      <NoCapture>{patient.alias}</NoCapture>
                    </Heading>
                  </div>
                  <div className="flex gap-2">
                    <Building2 />
                    <span className="line-clamp-1">{getSubtenantLabel(currentUser, patient.tenantId)}</span>
                  </div>
                </div>

                <ChevronRight />
              </CardHeader>
              <CardContent>
                {patient.lastActivityDate && (
                  <div className="flex gap-2">Last session on {formatDate(new Date(patient.lastActivityDate))}</div>
                )}
              </CardContent>
            </Card>
          </Link>
        </li>
      ))}
    </ul>
  );
}
